// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/external_tickets/v1/external_tickets.proto" (package "c1.api.external_tickets.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { ExternalTickets } from "./external_tickets";
import type { ProcessExternalTicketForBulkActionResponse } from "./external_tickets";
import type { ProcessExternalTicketForBulkActionRequest } from "./external_tickets";
import type { GetExternalTicketResponse } from "./external_tickets";
import type { GetExternalTicketRequest } from "./external_tickets";
import type { DeleteExternalTicketProvisionerConfigResponse } from "./external_tickets";
import type { DeleteExternalTicketProvisionerConfigRequest } from "./external_tickets";
import type { UpdateExternalTicketProvisionerConfigResponse } from "./external_tickets";
import type { UpdateExternalTicketProvisionerConfigRequest } from "./external_tickets";
import type { GetConnectorExternalTicketProvisionerResponse } from "./external_tickets";
import type { GetConnectorExternalTicketProvisionerRequest } from "./external_tickets";
import type { GetExternalTicketProvisionerConfigResponse } from "./external_tickets";
import type { GetExternalTicketProvisionerConfigRequest } from "./external_tickets";
import type { ListExternalTicketProvisionerConfigResponse } from "./external_tickets";
import type { ListExternalTicketProvisionerConfigRequest } from "./external_tickets";
import type { CreateExternalTicketProvisionerConfigResponse } from "./external_tickets";
import type { CreateExternalTicketProvisionerConfigRequest } from "./external_tickets";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ListConnectorExternalTicketProvisionerResponse } from "./external_tickets";
import type { ListConnectorExternalTicketProvisionerRequest } from "./external_tickets";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.external_tickets.v1.ExternalTickets
 */
export interface IExternalTicketsClient {
    /**
     * @generated from protobuf rpc: ListConnectorExternalTicketProvisioner
     */
    listConnectorExternalTicketProvisioner(input: ListConnectorExternalTicketProvisionerRequest, options?: RpcOptions): UnaryCall<ListConnectorExternalTicketProvisionerRequest, ListConnectorExternalTicketProvisionerResponse>;
    /**
     * @generated from protobuf rpc: CreateExternalTicketProvisionerConfig
     */
    createExternalTicketProvisionerConfig(input: CreateExternalTicketProvisionerConfigRequest, options?: RpcOptions): UnaryCall<CreateExternalTicketProvisionerConfigRequest, CreateExternalTicketProvisionerConfigResponse>;
    /**
     * @generated from protobuf rpc: ListExternalTicketProvisionerConfig
     */
    listExternalTicketProvisionerConfig(input: ListExternalTicketProvisionerConfigRequest, options?: RpcOptions): UnaryCall<ListExternalTicketProvisionerConfigRequest, ListExternalTicketProvisionerConfigResponse>;
    /**
     * @generated from protobuf rpc: GetExternalTicketProvisionerConfig
     */
    getExternalTicketProvisionerConfig(input: GetExternalTicketProvisionerConfigRequest, options?: RpcOptions): UnaryCall<GetExternalTicketProvisionerConfigRequest, GetExternalTicketProvisionerConfigResponse>;
    /**
     * @generated from protobuf rpc: GetConnectorExternalTicketProvisioner
     */
    getConnectorExternalTicketProvisioner(input: GetConnectorExternalTicketProvisionerRequest, options?: RpcOptions): UnaryCall<GetConnectorExternalTicketProvisionerRequest, GetConnectorExternalTicketProvisionerResponse>;
    /**
     * @generated from protobuf rpc: UpdateExternalTicketProvisionerConfig
     */
    updateExternalTicketProvisionerConfig(input: UpdateExternalTicketProvisionerConfigRequest, options?: RpcOptions): UnaryCall<UpdateExternalTicketProvisionerConfigRequest, UpdateExternalTicketProvisionerConfigResponse>;
    /**
     * @generated from protobuf rpc: DeleteExternalTicketProvisionerConfig
     */
    deleteExternalTicketProvisionerConfig(input: DeleteExternalTicketProvisionerConfigRequest, options?: RpcOptions): UnaryCall<DeleteExternalTicketProvisionerConfigRequest, DeleteExternalTicketProvisionerConfigResponse>;
    /**
     * @generated from protobuf rpc: GetExternalTicket
     */
    getExternalTicket(input: GetExternalTicketRequest, options?: RpcOptions): UnaryCall<GetExternalTicketRequest, GetExternalTicketResponse>;
    /**
     * @generated from protobuf rpc: ProcessExternalTicketForBulkAction
     */
    processExternalTicketForBulkAction(input: ProcessExternalTicketForBulkActionRequest, options?: RpcOptions): UnaryCall<ProcessExternalTicketForBulkActionRequest, ProcessExternalTicketForBulkActionResponse>;
}
/**
 * @generated from protobuf service c1.api.external_tickets.v1.ExternalTickets
 */
export class ExternalTicketsClient implements IExternalTicketsClient, ServiceInfo {
    typeName = ExternalTickets.typeName;
    methods = ExternalTickets.methods;
    options = ExternalTickets.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: ListConnectorExternalTicketProvisioner
     */
    listConnectorExternalTicketProvisioner(input: ListConnectorExternalTicketProvisionerRequest, options?: RpcOptions): UnaryCall<ListConnectorExternalTicketProvisionerRequest, ListConnectorExternalTicketProvisionerResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListConnectorExternalTicketProvisionerRequest, ListConnectorExternalTicketProvisionerResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateExternalTicketProvisionerConfig
     */
    createExternalTicketProvisionerConfig(input: CreateExternalTicketProvisionerConfigRequest, options?: RpcOptions): UnaryCall<CreateExternalTicketProvisionerConfigRequest, CreateExternalTicketProvisionerConfigResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateExternalTicketProvisionerConfigRequest, CreateExternalTicketProvisionerConfigResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListExternalTicketProvisionerConfig
     */
    listExternalTicketProvisionerConfig(input: ListExternalTicketProvisionerConfigRequest, options?: RpcOptions): UnaryCall<ListExternalTicketProvisionerConfigRequest, ListExternalTicketProvisionerConfigResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListExternalTicketProvisionerConfigRequest, ListExternalTicketProvisionerConfigResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetExternalTicketProvisionerConfig
     */
    getExternalTicketProvisionerConfig(input: GetExternalTicketProvisionerConfigRequest, options?: RpcOptions): UnaryCall<GetExternalTicketProvisionerConfigRequest, GetExternalTicketProvisionerConfigResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExternalTicketProvisionerConfigRequest, GetExternalTicketProvisionerConfigResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetConnectorExternalTicketProvisioner
     */
    getConnectorExternalTicketProvisioner(input: GetConnectorExternalTicketProvisionerRequest, options?: RpcOptions): UnaryCall<GetConnectorExternalTicketProvisionerRequest, GetConnectorExternalTicketProvisionerResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetConnectorExternalTicketProvisionerRequest, GetConnectorExternalTicketProvisionerResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateExternalTicketProvisionerConfig
     */
    updateExternalTicketProvisionerConfig(input: UpdateExternalTicketProvisionerConfigRequest, options?: RpcOptions): UnaryCall<UpdateExternalTicketProvisionerConfigRequest, UpdateExternalTicketProvisionerConfigResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateExternalTicketProvisionerConfigRequest, UpdateExternalTicketProvisionerConfigResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteExternalTicketProvisionerConfig
     */
    deleteExternalTicketProvisionerConfig(input: DeleteExternalTicketProvisionerConfigRequest, options?: RpcOptions): UnaryCall<DeleteExternalTicketProvisionerConfigRequest, DeleteExternalTicketProvisionerConfigResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteExternalTicketProvisionerConfigRequest, DeleteExternalTicketProvisionerConfigResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetExternalTicket
     */
    getExternalTicket(input: GetExternalTicketRequest, options?: RpcOptions): UnaryCall<GetExternalTicketRequest, GetExternalTicketResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExternalTicketRequest, GetExternalTicketResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ProcessExternalTicketForBulkAction
     */
    processExternalTicketForBulkAction(input: ProcessExternalTicketForBulkActionRequest, options?: RpcOptions): UnaryCall<ProcessExternalTicketForBulkActionRequest, ProcessExternalTicketForBulkActionResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<ProcessExternalTicketForBulkActionRequest, ProcessExternalTicketForBulkActionResponse>("unary", this._transport, method, opt, input);
    }
}
